import React from "react";
import {
    AuthTitleBlock,
    TitleText,
    ButtonWrapper,
    SubmitButton,
    AuthIcon,
    IconWraper,
    RegularText,
    FormContainer,
} from "../../../AuthForm/AuthSteps/Auth.elements";
import { CheckCircle } from "@/icons";

const ChangePasswordConfirmation = (props) => {
    return (
        <>
            <IconWraper>
                <AuthIcon as={CheckCircle} />
            </IconWraper>

            <FormContainer>
                <AuthTitleBlock>
                    <TitleText>PASSWORD CHANGED!</TitleText>
                </AuthTitleBlock>
                <RegularText>Your password has been changed successfully.</RegularText>
            </FormContainer>

            <ButtonWrapper>
                <SubmitButton buttonState="auth" type="button" onClick={props.close}>
                    Continue
                </SubmitButton>
            </ButtonWrapper>
        </>
    );
};

export default ChangePasswordConfirmation;
